import { api } from "constants/RotasAPI";
import usePostAlterarCondominioContextoToken from "hooks/condominio/usePostAlterarCondominioContextoToken";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import { Page } from "types/dto/Page";
import { InadimplenciaDTO } from "types/dto/RegistroInadimplenciaDTO";

type Request = {
  unidadeId?: number;
  condominioId?: number;
  deveBuscarIdsInadimplencias: boolean;
};

export const useGetIdsInadimplenciasIniciarAcordo = (request: Request) => {
  const { alterarCondominioContextoToken } = usePostAlterarCondominioContextoToken();
  const { iniciarAcordosV1 } = IntegracaoV1();

  const onSuccess = async (resp: number[]) => {
    if (request.condominioId) {
      await alterarCondominioContextoToken(request.condominioId);
      iniciarAcordosV1(resp);
    }
  };

  const onError = () => {
    toast.error("Erro ao buscar todas as inadimplências");
  };

  return useFetch<Page<InadimplenciaDTO>>({
    key: ["inadimplencias", request.unidadeId],
    url: api.contaReceber.getIdsInadimplencias,
    params: request,
    enabled: request.unidadeId !== undefined && request.deveBuscarIdsInadimplencias,
    onSuccess,
    onError,
  });
};
